module.exports = __webpack_public_path__ + "static/media/6-supply-chains.40bc12d2.jpg";